import { MAX_YEAR, DEFINITE_ARTICLE } from "./Constants";

class Model {
	constructor(data) {
			this.data = data;
			this.default_year = MAX_YEAR;
	}
	get(key, prop, year=this.default_year){
		return typeof this.data[key] == 'undefined' ? 0 : prop == 'score' ? this.getScore(key, year) : this.data[key].years[year][prop];
	}
	getScore(key, year=this.default_year) {
		return typeof this.data[key] == 'undefined' ? 0 : this.getGRI(key, year) + this.getSHI(key, year);
	}
	getSHI(key, year=this.default_year) {
		return typeof this.data[key] == 'undefined' ? 0 : this.data[key].years[year].shi;
	}
	getGRI(key, year=this.default_year) {
		return typeof this.data[key] == 'undefined' ? 0 : this.data[key].years[year].gri;
	}
	getName(key, article=false) {
		return typeof this.data[key] == 'undefined' ? key : article ? `${~DEFINITE_ARTICLE.indexOf(key) ? `the ` : `` }${this.data[key].name}` : this.data[key].name;
	}
	getPopulation(key, year=this.default_year) {
		return typeof this.data[key] == 'undefined' ? 0 : this.data[key].years[MAX_YEAR].pop;
	}
	getRegion(key){
		return typeof this.data[key] == 'undefined' ? 0 : this.data[key].region;
	}
	getDemo(key) {
		return typeof this.data[key] == 'undefined' ? 0 : this.data[key].demo;
	}
	getAbbrev(key) {
		return typeof this.data[key] == 'undefined' ? 0 : this.data[key].abbrev;
	}
}

export default Model;
